import styled from "styled-components";
import { theme } from "@styles/theme";

const Circle = styled.div<{ checked?: boolean; }>`  
    display: inline-block;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    border: 0.8px solid ${props => props.checked ?  theme.colors.primary : theme.colors.primary };
    margin: 0px 10px;
    flex-shrink: 0;

    & > .checkbox-icon {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${theme.colors.primary_80};
    }
`

export default function Checkbox({ checked, onCheck }:{ checked?: boolean; onCheck?: ()=>void }) {
    return (
        <>
            <Circle checked={checked} onClick={onCheck}>
                {checked? <div className="checkbox-icon"/> : null}
            </Circle>
        </>
    )
}